import { useState } from 'react';

import { KeyOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Row, Tooltip, Typography } from 'antd';
import cn from 'classnames';
import type { User } from 'models/user';
import { useAppSelector } from 'services/redux/configureStore';
import { width } from 'utils/helpers/width';

import { AddPermissionModal } from './add-permission-modal/AddPermissionModal';
import { GlobalPermissions } from './global-permissions/GlobalPermissions';
import styles from './Permissions.module.css';
import { TrackersPermissions } from './trackers-permissions/TrackersPermissions';

const { Title } = Typography;

interface Props {
  userData: User;
}

export const Permissions = ({ userData }: Props) => {
  const [isAddPermissionVisible, setIsPermissionVisible] = useState(false);

  const isDarkMode = useAppSelector((state) => state.theme.isDarkMode);

  return (
    <>
      <Card
        bordered={false}
        className={cn(styles.card, { [styles.card_dark]: isDarkMode })}
        style={{
          boxShadow: isDarkMode ? 'rgb(255 255 255 / 20%) 0px 0px 2px 0px' : '0px 0px 2px 0 rgb(192 192 192)',
        }}
        title={
          <Row align="middle" justify="space-between">
            <Title level={5} style={{ margin: '0' }}>
              Права пользователя
            </Title>
            <Tooltip title={width < 820 ? '' : 'Добавить запись'} mouseEnterDelay={0.4}>
              <Button
                id="me-add-keitaro-modal-open-button"
                icon={<KeyOutlined />}
                onClick={() => setIsPermissionVisible(true)}
              />
            </Tooltip>
          </Row>
        }
      >
        <Flex gap={12} vertical>
          {Boolean(userData.trackers?.length) && (
            <TrackersPermissions userId={userData.id} trackers={userData.trackers ?? []} />
          )}
          <GlobalPermissions user={userData} permissions={userData.permissions ?? {}} />
        </Flex>
      </Card>

      <AddPermissionModal
        isModalVisible={isAddPermissionVisible}
        setIsModalVisible={setIsPermissionVisible}
        userId={userData.id}
      />
    </>
  );
};
